import { useState } from "react";
import { useTranslation } from "react-i18next";
import { PartnerPromotionForm } from "webapp/components/PartnerPromotionForm";
import { Header, TitleBar } from "webapp/components";

export default function PartnerPromotion(props) {
  const { t } = useTranslation();

  const [logo] = useState(props.logo);
  const [currState] = useState(props.currState);
  const [context] = useState(props.context);
  const [data] = useState(props.data);

  const LocateUserObj = {
    img: props.logo,
    partner: props.currState.partner,
    fragment: (
      <>
        <p className="mb-0">
          <strong>Here is the promotion coupon for you!</strong>
          <br />
          <span style={{ color: "#999" }}>
            <strong>Here is the promotion coupon for you!</strong>
          </span>
        </p>
      </>
    ),
  };

  return (
    <>
      <Header currState={props.currState} disableBack={true} information="Promotion Page" />
      <TitleBar data={LocateUserObj} />
      <PartnerPromotionForm logo={logo} currState={currState} context={context} data={data} />
    </>
  );
}
